exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1jM3THosy72OghJVmaxen-{font-size:16px;cursor:pointer;margin-left:2px}._2RYIOmA5LVv7iMQ9Tg-i_d{font-size:16px;cursor:pointer;margin-left:2px}\n", ""]);

// Exports
exports.locals = {
	"basic": "_1jM3THosy72OghJVmaxen-",
	"premium": "_2RYIOmA5LVv7iMQ9Tg-i_d"
};